module.exports = __webpack_public_path__ + "static/media/annsofi.profile.d59e7a4e.JPG";